import { RootState } from 'store'

export const dialogDataSelector = (state: RootState) => state.dialog
